import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { faComment } from '@fortawesome/pro-regular-svg-icons/faComment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { keys, omit } from 'lodash';
import PropTypes from 'prop-types';

import { buildGetDrawerOpen } from 'selectors/drawers';

import { MESSENGER_VIEW_DRAWER_KEY } from 'features/drawers/keys';
import { toggleMessengerShown } from 'features/messengerv2/actions';

import Icon from 'components/Icon';
import Text from 'components/Text';

import cxHelpers from 'util/className';
import { trackUxEvent } from 'util/tracking';
import {
  EVENT_ACTIONS,
  EVENT_CATEGORIES,
  PRODUCT_AREAS,
} from 'util/tracking_constants';

import withNavItemData from '../../hocs/withNavItemData';
import NavItem from '../NavItem';
const PROP_TYPES = {
  messengerIsShown: PropTypes.bool.isRequired,
  onToggleMessenger: PropTypes.func.isRequired,
  showIndicator: PropTypes.bool.isRequired,
  isText: PropTypes.bool,
  newHeader: PropTypes.bool,
};

const PROP_TYPE_KEYS = keys(PROP_TYPES);

@withNavItemData('messenger')
@connect(
  (state, props) => ({
    messengerIsShown: buildGetDrawerOpen(MESSENGER_VIEW_DRAWER_KEY)(
      state,
      props
    ),
    showIndicator: state.get('messaging')?.totalUnreadCount > 0,
  }),
  { onToggleMessenger: toggleMessengerShown }
)
@cxHelpers('MessengerNavItem')
export default class MessengerNavItem extends PureComponent {
  static propTypes = PROP_TYPES;

  handleToggleMessenger = () => {
    trackUxEvent({
      productArea: PRODUCT_AREAS.NAVIGATION,
      eventCategory: EVENT_CATEGORIES.MESSAGE_DRAWER,
      eventAction: EVENT_ACTIONS.BUTTON_CLICKED,
    });

    this.props.onToggleMessenger();
  };

  icon() {
    if (this.props.newHeader) {
      return (
        <Text fs24>
          <FontAwesomeIcon icon={faComment} color="white" />
        </Text>
      );
    }

    return <Icon size={16} type="message2" />;
  }

  render() {
    return (
      <NavItem
        {...omit(this.props, PROP_TYPE_KEYS)}
        className={this.cx()}
        onClick={this.handleToggleMessenger}
        active={this.props.messengerIsShown}
        indicator={this.props.showIndicator}
      >
        {this.props.isText ? (
          <Text className="text-messaging" fs14 i18n="nav_links.messaging" />
        ) : (
          this.icon()
        )}
      </NavItem>
    );
  }
}
